import React, { useEffect, useState } from "react";
import { Download, Share, Plus, X } from "lucide-react";

const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);
const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

export const InstallAppButton = ({ className = "", label = "Download App" }) => {
  const [canPrompt, setCanPrompt] = useState(!!window.__deferredInstallPrompt);
  const [installed, setInstalled] = useState(isStandalone());
  const [showIos, setShowIos] = useState(false);

  useEffect(() => {
    const onInstallable = () => setCanPrompt(true);
    const onInstalled = () => { setInstalled(true); setCanPrompt(false); };
    window.addEventListener("pwa-installable", onInstallable);
    window.addEventListener("pwa-installed", onInstalled);
    return () => {
      window.removeEventListener("pwa-installable", onInstallable);
      window.removeEventListener("pwa-installed", onInstalled);
    };
  }, []);

  if (installed) return null;

  const install = async () => {
    const dp = window.__deferredInstallPrompt;
    if (dp) {
      dp.prompt();
      const { outcome } = await dp.userChoice;
      if (outcome === "accepted") { window.__deferredInstallPrompt = null; setCanPrompt(false); }
    } else {
      setShowIos(true);
    }
  };

  return (
    <>
      <button onClick={install} data-testid="install-app-btn"
        className={className || "btn-outline-gold px-5 py-2.5 text-xs uppercase tracking-widest rounded-sm flex items-center gap-2"}>
        <Download size={15} /> {label}
      </button>
      {showIos && (
        <div className="fixed inset-0 z-[120] flex items-center justify-center bg-black/75 p-6" onClick={() => setShowIos(false)}>
          <div className="matte-card p-7 w-full max-w-sm text-center" onClick={(e) => e.stopPropagation()} data-testid="install-ios-modal">
            <button onClick={() => setShowIos(false)} className="absolute top-4 right-4 text-white/40 hover:text-white"><X size={18} /></button>
            <h3 className="font-serif text-2xl gold-text">Add Chef Plated to your Home Screen</h3>
            <p className="text-white/60 text-sm mt-3">On iPhone or iPad, install the app in two taps:</p>
            <div className="mt-5 space-y-3 text-left">
              <div className="flex items-center gap-3 text-white/80 text-sm">
                <span className="h-8 w-8 rounded-sm bg-gold/10 border border-gold/30 flex items-center justify-center text-gold shrink-0"><Share size={16} /></span>
                Tap the <span className="text-gold">Share</span> button in your browser toolbar.
              </div>
              <div className="flex items-center gap-3 text-white/80 text-sm">
                <span className="h-8 w-8 rounded-sm bg-gold/10 border border-gold/30 flex items-center justify-center text-gold shrink-0"><Plus size={16} /></span>
                Choose <span className="text-gold">Add to Home Screen</span>.
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default InstallAppButton;
